// extracted by mini-css-extract-plugin
export default {"buttonWrap":"limited-stock-modal_buttonWrap__2668b","amendFailed":"limited-stock-modal_amendFailed__52cac"};